import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

// HACK According to the Spanish orthotypography rules for the Spain variety,
// numbers of less than 5 digits should not be separated by thousands. Unicode's
// ICU syntax provides a `group-on-aligned` skeleton as a way to force the
// separation for alignment reasons, but it's implementation through the browser
// Intl API lacks that functionality, rendering it unusable in this context.
// As a workaround for this limitation, this hook forces the orthotypography
// formatting rules for the Argentina variety, which separates 4-digit numbers.
// IMPORTANT Numeric interpolations in i18n messages must be treated as strings,
// not as numbers, after formatting numbers with this hook.
const useFormatNumber = () => {
  const intl = useIntl()

  const numberFormatter = useMemo(() => {
    const localeHack = intl.locale === 'es' ? 'es-AR' : intl.locale

    return new Intl.NumberFormat(localeHack, {
      minimumFractionDigits: 2,
    })
  }, [intl.locale])

  const formatNumber = useCallback(
    value => numberFormatter.format(value),
    [numberFormatter],
  )

  return formatNumber
}

export default useFormatNumber
